// extracted by mini-css-extract-plugin
export default {"custom-mach-refresh":"zObjp_custom-mach-refresh","custom-mach-refresh--loading":"FIrk9_custom-mach-refresh--loading"};